import React from 'react'

import TextInput from '../../../components/text-input'
import Education from '../education'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import ListLevelHeader from '../../../components/utils/list-element-header'

class LinkComponent extends Education {
  render() {
    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            <ListLevelHeader what={this.state.model.label} alternative={this.state.model.url} />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="label"
                label="Label"
                value={this.state.model.label}
                update={this.update}
              />

              <TextInput
                field="url"
                label="Link"
                value={this.state.model.url}
                update={this.update}
              />
            </div>
            <div className="button-remove-element" onClick={this.removeElement}>
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

LinkComponent.defaultProperties = { open: false }
export default LinkComponent
